import React from 'react';
import { Microscope, FlaskConical, Leaf, TestTube } from 'lucide-react';
import '../styles/ProcessSection.css';

const ProcessSection = () => {
  const processSteps = [
    {
      icon: <Leaf size={28} />,
      title: 'Organic Substrates',
      description: 'We begin with 100% organic, vegan growing substrates, ensuring purity from the very foundation.'
    },
    {
      icon: <Microscope size={28} />,
      title: 'Controlled Cultivation',
      description: 'State-of-the-art indoor cultivation in sterile, controlled environments for optimal growth conditions.'
    },
    {
      icon: <TestTube size={28} />,
      title: 'Lab Testing',
      description: 'Every batch undergoes rigorous testing for cordycepin content, potency, safety, and purity verification.'
    },
    {
      icon: <FlaskConical size={28} />,
      title: 'Full Traceability',
      description: 'Complete transparency with batch-level traceability from culture to your doorstep.'
    }
  ];

  return (
    <section id="process" className="process-section section-padding">
      <div className="container">
        <div className="process-header">
          <h2 className="heading-1">
            Our <span className="accent-orange">Process</span> & Quality Control
          </h2>
          <p className="body-large process-intro">
            From culture to cultivation, every stage is executed with scientific precision and unwavering commitment to quality.
          </p>
        </div>

        <div className="process-content">
          <div className="process-steps">
            {processSteps.map((step, index) => (
              <div key={index} className="process-step">
                <div className="step-icon accent-orange">
                  {step.icon}
                </div>
                <div className="step-content">
                  <h3 className="heading-3">{step.title}</h3>
                  <p className="body-regular">{step.description}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="process-image-section">
            <img 
              src="https://customer-assets.emergentagent.com/job_adapt-wellness/artifacts/nd3yk2gd_download.webp" 
              alt="Cordyceps militaris growing in controlled laboratory cultivation"
              className="process-image"
            />
          </div>
        </div>

        <div className="quality-highlights">
          <div className="quality-item">
            <span className="quality-label">Vegan</span>
          </div>
          <div className="quality-item">
            <span className="quality-label">Non-Synthetic</span>
          </div>
          <div className="quality-item">
            <span className="quality-label">Lab-Verified</span>
          </div>
          <div className="quality-item">
            <span className="quality-label">Zero Fillers</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;